<template>
    <div class="container mx-0">
        <div class="row mt-3">
            <div class="col-12">
                <h4 class="d-inline">Settings</h4>
                <button class="float-right btn btn-primary" v-bind:disabled="saving" v-on:click="save()">Save</button>
            </div>
        </div>

        <div class="row mt-3">
            <div class="col-12">
                <label for="">Company Name</label>
                <input type="text" class="form-control" v-model="company_edit.name">
            </div>
        </div>

        <!--<div class="row mt-3">-->
        <!--    <div class="col-4">-->
        <!--        Logo-->
        <!--    </div>-->
        <!--    <div class="col-4">-->
        <!--        Email Logo-->
        <!--    </div>-->
        <!--    <div class="col-4">-->
        <!--        Colors-->
        <!--    </div>-->
        <!--</div>-->
    </div>
</template>

<script>
	export default {
		name: "SettingsPage",
        props: [
        	'company',
            'store_url'
        ],

        data(){
			return {
				company_edit: null,

                saving: false,
            }
        },

        beforeMount() {
			this.company_edit = this.company;
		},

        methods: {
			save(){
				let _this = this;

				if (_this.saving)
					return;

				_this.saving = true;
				axios.post(_this.store_url, {
					name: _this.company_edit.name
                })
                    .then(function (){
                    	window.location.reload();
                    })
                    .catch(function (){
                    	_this.saving = false;
                        Vue.$toast.open({
                            message: 'Couldn\'t save settings',
                            type: 'error'
                        });
                    });
            }
        }
	}
</script>
